import { ICreateUserVO } from "../model/AccountModels";
import { ApiWithoutToken } from "./api";

interface IOrgCreatedVo {
    internalName: string;
}

export async function CreateUserAccount(input: ICreateUserVO) {
    const response = await ApiWithoutToken.post<IOrgCreatedVo>(`Account`, input);
    return response.data;
}